import { useQuery } from "@tanstack/react-query";
import serialsClient from "../../../api/serials";

const useTestSerials = () => {
  return useQuery({
    queryKey: ["serials", "test"],
    queryFn: () => serialsClient.listTestSerials(),
  });
};

export default useTestSerials;
